import { render, staticRenderFns } from "./XiangMu2_辉县版本.vue?vue&type=template&id=389c2a3e&scoped=true"
import script from "./XiangMu2_辉县版本.vue?vue&type=script&lang=js"
export * from "./XiangMu2_辉县版本.vue?vue&type=script&lang=js"
import style0 from "./XiangMu2_辉县版本.vue?vue&type=style&index=0&id=389c2a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c2a3e",
  null
  
)

export default component.exports